module.exports = __webpack_public_path__ + "static/media/not_exists.4efa1288.svg";